import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Building2, Home, Plus } from 'lucide-react';

interface AssetsEmptyStateProps {
  onAddAsset?: () => void;
}

export function AssetsEmptyState({ onAddAsset }: AssetsEmptyStateProps) {
  return (
    <Card className="border-dashed border-2 border-muted-foreground/25 bg-muted/5">
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        {/* Icon */}
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Home className="w-8 h-8 text-primary" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
            <Building2 className="w-4 h-4 text-secondary-foreground" />
          </div>
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold mb-2">No Properties Yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Start building your real estate portfolio by adding your first
          property. Track income, expenses, and performance all in one place.
        </p>

        {/* Action Button */}
        {onAddAsset && (
          <Button onClick={onAddAsset} className="flex items-center">
            <Plus className="w-4 h-4 mr-2" />
            Add Your First Property
          </Button>
        )}

        {/* Additional Info */}
        <div className="mt-6 text-xs text-muted-foreground">
          <p>Track property details, financial performance, and</p>
          <p>generate comprehensive reports for your investments.</p>
        </div>
      </CardContent>
    </Card>
  );
}
